import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import Status from "components/presentation/Status";
import { getDateTimeFormat } from "helpers/utils";


export function CompetitorBlock(competitor) {

    let seed = ''
    let competitorBracket;
    if (competitor.co_seed) {
        seed = '(' + competitor.co_seed + ')'
    }

    competitorBracket = (competitor?.resultItem?.teamAthletes)
        ? <div className="w-85"><Competitor hidePicture={true} hideNoc={true} noLink={true} teamAthletes={competitor?.resultItem?.teamAthletes} showSeed={true} seed={competitor?.co_seed} onlyShortName={true} /></div>
        : <div className="w-85"> <Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} showSeed={true} seed={competitor?.co_seed} onlyShortName={true} /></div>


    //Check if the game is singles or doubles

    return (
        <div className='score-competitor-container d-flex justify-content-start'>
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name d-flex align-items-center'>
                {competitorBracket}
            </div>
        </div>
    )
}

export function Footer({ data }) {
    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} /></>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = date
    const numberGame = data?.bracketItemCode
    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex justify-content-between w-100">
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start me-5'>{dateComponent}</div>}
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-end'><Label data='HeaderMatch' /> {numberGame}</div>}
            </div>
        </>
    )
}
